// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataeurm } from "../../../icons/full/build/icon-stataeurm.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataeurmIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataeurm.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataeurmIcon.displayName = 'StataeurmIcon';
}

export default StataeurmIcon;